import * as z from "zod";
import { GameSchema, UserDDBSchema, UserSchema } from "./general";

export const LobbyCreatedResponseSchema = z.object({
    type: z.literal("lobby_created"),
    lobbyId: z.string(),
});

export const PlayerJoinedResponseSchema = z.object({
    type: z.literal("player_joined"),
    newUser: UserSchema,
    users: z.object({
        p1: UserSchema,
        p2: UserSchema.optional(),
    }),
});

export const StartGameResponseSchema = z.object({
    type: z.literal("start_game"),
    game: GameSchema,
});

export const PlayerMoveResponseSchema = z.object({
    type: z.literal("player_move"),
    game: GameSchema,
});

export const RejoinedLobbyResponseSchema = z.object({
    type: z.literal("rejoined_lobby"),
    newUser: UserSchema,
    users: z.object({
        p1: UserSchema,
        p2: UserSchema.optional(),
    }),
    game: GameSchema,
});

export const PlayAgainRequestResponseSchema = z.object({
    type: z.literal("play_again_request"),
});

export const ForfeitResponse = z.object({
    type: z.literal("forfeit"),
    winner: UserDDBSchema,
});

export const PlayAgainResponseSchema = z.object({
    type: z.literal("play_again_response"),
    response: z.union([z.literal("accept"), z.literal("deny")]),
});

export const SentPlayAgainResponseSchema = z.object({
    type: z.literal("sent_play_again_request"),
});

export const PongResponseSchema = z.object({ type: z.literal("pong") });

export const FullGameResponseSchema = z.object({
    type: z.literal("error"),
    error: z.literal("full_game"),
});
export const GameNotFoundResponseSchema = z.object({
    type: z.literal("error"),
    error: z.literal("game_not_found"),
});
export const ErrorResponseSchema = z.discriminatedUnion("error", [
    GameNotFoundResponseSchema,
    FullGameResponseSchema,
]);

export const AllResponsesSchema = z.discriminatedUnion("type", [
    PongResponseSchema,
    PlayAgainResponseSchema,
    ForfeitResponse,
    PlayAgainRequestResponseSchema,
    RejoinedLobbyResponseSchema,
    PlayerMoveResponseSchema,
    StartGameResponseSchema,
    PlayerJoinedResponseSchema,
    LobbyCreatedResponseSchema,
    SentPlayAgainResponseSchema,
    ErrorResponseSchema,
]);
